/**
 * 通用js方法封装处理
 * Copyright (c) 2019 jichu
 */

let config = window.config.servers.default + '/api';
const baseURL = process.env.VUE_APP_BASE_API;
let token = localStorage.getItem('token')

// 日期格式化
export function parseTime (time, pattern) {
  if (arguments.length === 0 || !time)
  {
    return null;
  }
  const format = pattern || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object")
  {
    date = time;
  } else
  {
    if (typeof time === "string" && /^[0-9]+$/.test(time))
    {
      time = parseInt(time);
    } else if (typeof time === "string")
    {
      time = time.replace(new RegExp(/-/gm), "/");
    }
    if (typeof time === "number" && time.toString().length === 10)
    {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a")
    {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10)
    {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

// 表单重置
export function resetForm (refName) {
  if (this.$refs[refName])
  {
    this.$refs[refName].resetFields();
  }
}

// 添加日期范围
export function addDateRange (params, dateRange, propName) {
  var search = params;
  search.params = {};
  if (null != dateRange && "" != dateRange)
  {
    if (typeof propName === "undefined")
    {
      search.params["beginTime"] = dateRange[0];
      search.params["endTime"] = dateRange[1];
    } else
    {
      search.params["begin" + propName] = dateRange[0];
      search.params["end" + propName] = dateRange[1];
    }
  }
  return search;
}

// 回显数据字典
export function selectDictLabel (datas, value) {
  var actions = [];
  Object.keys(datas).some((key) => {
    if (datas[key].dictValue == "" + value)
    {
      actions.push(datas[key].dictLabel);
      return true;
    }
  });
  return actions.join("");
}

// 回显数据字典（字符串数组）
export function selectDictLabels (datas, value, separator) {
  var actions = [];
  var currentSeparator = undefined === separator ? "," : separator;
  var temp = value.split(currentSeparator);
  Object.keys(value.split(currentSeparator)).some((val) => {
    Object.keys(datas).some((key) => {
      if (datas[key].dictValue == "" + temp[val])
      {
        actions.push(datas[key].dictLabel + currentSeparator);
      }
    });
  });
  return actions.join("").substring(0, actions.join("").length - 1);
}

// 通用下载方法
export function download1 (fileName) {
  // console.log(window.location.protocol, ";;;;");
  // if (fileName) {
  // window.location.href =
  //   window.location.protocol + baseURL +
  //   "/common/download?fileName=" +
  //   encodeURI(fileName) +
  //   "&delete=" +
  //   true;
  // var a = document.createElement("a");
  // a.id = "expertFile";
  // // a.setAttribute("target", "_blank");
  // a.href = baseURL + "/common/download?fileName=" + encodeURI(fileName);
  // document.body.append(a);
  // a.click();
  // document.getElementById("expertFile").remove();
  // var download_file = {};
  // if (typeof download_file.iframe == "undefined") {
  //   var iframe = document.createElement("iframe");
  //   download_file.iframe = iframe;
  //   document.body.appendChild(download_file.iframe);
  // }
  // download_file.iframe.src =
  //   baseURL +
  //   "/common/download?fileName=" +
  //   encodeURI(fileName) +
  //   "&delete=" +
  //   true;
  // download_file.iframe.style.display = "none";
  // }
}
export default {
  bind (el, binding) {
    el.addEventListener("click", () => {
      const a = document.createElement("a");
      //   let url = baseUrl + binding.value // 若是不完整的url则需要拼接baseURL
      const url = binding.value; // 完整的url则直接使用
      // 这里是将url转成blob地址，
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          // 将链接地址字符内容转变成blob地址
          a.href = URL.createObjectURL(blob);
          console.log(a.href);
          a.download = ""; // 下载文件的名字
          // a.download = url.split('/')[url.split('/').length -1] //  // 下载文件的名字
          document.body.appendChild(a);
          a.click();
        });
    });
  },
};
// 字符串格式化(%s )
export function sprintf (str) {
  var args = arguments,
    flag = true,
    i = 1;
  str = str.replace(/%s/g, function () {
    var arg = args[i++];
    if (typeof arg === "undefined")
    {
      flag = false;
      return "";
    }
    return arg;
  });
  return flag ? str : "";
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty (str) {
  if (!str || str == "undefined" || str == "null")
  {
    return "";
  }
  return str;
}
// 获取图片类型
export function iconByTypeName (row) {
  return row.substring(row.lastIndexOf(".") + 1, row.length).toLowerCase();
}
// 改变时间分割点
export function dataXinyue (row) {
  return row.replace(/-/g, ".");
}
export function dataXinyueninayuer (row) {
  var newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(row)[0].replace(/-/g, ".");
  return newDate;
}
// 获取图片名称
export function iconByTypeNameUrls (row) {
  // let tar = "uploads/";
  // console.log(row.substring(row.lastIndexOf(tar) + 8, row.length));
  return row.substring(row.lastIndexOf("/") + 1);
  //获取最后一个/的位置
  // var site = row.lastIndexOf("/");
  // //截取最后一个/后的值
  // return row.substring(site + 1, row.length);
}
/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree (data, id, parentId, children) {
  let config = {
    id: id || "id",
    parentId: parentId || "parentId",
    childrenList: children || "children",
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data)
  {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null)
    {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data)
  {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null)
    {
      tree.push(d);
    }
  }

  for (let t of tree)
  {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList (o) {
    if (childrenListMap[o[config.id]] !== null)
    {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList])
    {
      for (let c of o[config.childrenList])
      {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}
/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams (params) {
  let result = "";
  for (const propName of Object.keys(params))
  {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && typeof value !== "undefined")
    {
      if (typeof value === "object")
      {
        for (const key of Object.keys(value))
        {
          if (value[key] !== null && typeof value[key] !== "undefined")
          {
            let params = propName + "[" + key + "]";
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else
      {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result;
}

// 验证是否为blob格式
export async function blobValidate (data) {
  try
  {
    const text = await data.text();
    JSON.parse(text);
    return false;
  } catch (error)
  {
    return true;
  }
}
//手机号脱敏
export function telhidden (params) {
  if (params && params.length == 11)
  {
    params = params.substring(0, 3) + "****" + params.substring(7);
  }
  return params;
}
//身份证
export function telhiddenCard (params) {
  params = params.replace(/^(.{6})(?:\d+)(.{4})$/, "$1****$2");
  return params;
}
/**
 * 数字格式化
 */
/**
 * 数字格式化：万、亿单位
 * @param {*} val
 * @returns
 */
export function numberFormat (val) {
  let nVal = ["", "", ""];
  let fr = 1000;
  let num = 3;
  while (val / fr >= 1)
  {
    fr *= 10;
    num += 1;
  }
  if (num <= 4)
  {
    // 千
    nVal[1] = "千";
    nVal[0] = parseInt(val / 1000) + "";
  } else if (num <= 8)
  {
    // 万
    const str = parseInt(num - 4) / 3 > 1 ? "千万" : "万";
    const fm = "万" === str ? 10000 : 10000000;
    nVal[1] = str;
    nVal[0] = val / fm + "";
  } else if (num <= 16)
  {
    // 亿
    let str = (num - 8) / 3 > 1 ? "千亿" : "亿";
    str = (num - 8) / 4 > 1 ? "万亿" : str;
    str = (num - 8) / 7 > 1 ? "千万亿" : str;

    let fm = 1;
    if ("亿" === str)
    {
      fm = 100000000;
    } else if ("千亿" === str)
    {
      fm = 100000000000;
    } else if ("万亿" === str)
    {
      fm = 1000000000000;
    } else if ("千万亿" === str)
    {
      fm = 1000000000000000;
    }
    nVal[1] = str;
    nVal[0] = parseInt(val / fm) + "";
  }
  if (val < 1000)
  {
    nVal[1] = "";
    nVal[0] = val + "";
  }
  return nVal.join("");
}
// 改变时间分割点
export function TimeDivision (row) {
  if (row != '' || row != null)
  {
    return row.replace(/-/g, '.');
  } else
  {
    return ''
  }
}
// 颜色转换/将16进制转换为RGB值
export function set16ToRgb (str) {
  var reg = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/
  if (!reg.test(str)) { return; }
  let newStr = (str.toLowerCase()).replace(/\#/g, '')
  let len = newStr.length;
  if (len == 3)
  {
    let t = ''
    for (var i = 0; i < len; i++)
    {
      t += newStr.slice(i, i + 1).concat(newStr.slice(i, i + 1))
    }
    newStr = t
  }
  let arr = [];
  for (var i = 0; i < 6; i = i + 2)
  {
    let s = newStr.slice(i, i + 2)
    arr.push(parseInt("0x" + s))
  }
  return arr.join(",");
}
// 获取私有文件预览地址
export function getPorivacyUrl (fileKey, secretKey = '') {
  return `${config}/file/download?fileUrl=${fileKey}&token=${token}`;
}
// 获取通用文件预览地址
export function getCommonUrl (fileKey, secretKey = '') {
  return `${config}/file/downloadNoAuth?fileUrl=${fileKey}`;
}


// WEBPACK FOOTER //
// ./src/utils/ruoyi.js